import type { AspectRatioInterface } from '@/types/generic'

export const ASPECT_RATIO_MAP: AspectRatioInterface = {
  '1/1': '1:1',
  '16/9': '16:9',
  '3/4': '3:4',
  '4/3': '4:3',
}

export const getRatio = (ratio: keyof AspectRatioInterface) => {
  const ar = ASPECT_RATIO_MAP[ratio]
  const [width, height] = ar.split(':')

  return { width: parseInt(width), height: parseInt(height), ar }
}

export const generateSrcsetEntry = (src: string, width: number): string => {
  return `${src} ${width}w`
}
